import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'sku-reports.items.page-title',
    defaultMessage: 'Item reports',
  },
  topSellerTile: {
    id: 'sku-reports.items.tile-top-seller',
    defaultMessage: 'Top seller (units)',
  },
  topEarnerTile: {
    id: 'sku-reports.items.tile-top-earner',
    defaultMessage: 'Top earner (revenue)',
  },
  itemsCount: {
    id: 'sku-reports.items.items-count',
    defaultMessage: '{count, plural, one {# item} other {# items}}',
  },
  itemColumn: {
    id: 'sku-reports.items.column-item',
    defaultMessage: 'Item',
  },
  locationColumn: {
    id: 'sku-reports.items.column-location',
    defaultMessage: 'Location',
  },
  menuColumn: {
    id: 'sku-reports.items.column-menu',
    defaultMessage: 'Menu',
  },
  categoryColumn: {
    id: 'sku-reports.items.column-category',
    defaultMessage: 'Category',
  },
  unitsSoldColumn: {
    id: 'sku-reports.items.column-units-sold',
    defaultMessage: 'Units sold',
  },
  ordersColumn: {
    id: 'sku-reports.items.column-orders',
    defaultMessage: 'Orders',
  },
  earningsColumn: {
    id: 'sku-reports.items.column-earnings',
    defaultMessage: 'Earnings',
  },
  emptyTitle: {
    id: 'sku-reports.items.empty-title',
    defaultMessage: 'No items found',
  },
  emptyBody: {
    id: 'sku-reports.items.empty-body',
    defaultMessage: 'Try searching for another item name or ID',
  },
});
